export default {
    namespaced: true,

    state: () => {
        return {
            loading: false,
            periods: [],
        }
    },

    getters: {
        loading(state) {
            return state.loading;
        },

        periods(state) {
            return state.periods.map((item, sl) => {
                item.sl = sl + 1;
                return item;
            });
        }
    },

    mutations: {
        setLoading(state, loading) {
            state.loading = loading
        },

        setPeriod(state, periods) {
            state.periods = periods
        },
    },

    actions: {
        async getPeriods(context, payload) {
            context.commit('setLoading', true);
        
            await axios.post(`${this.state.host}/get-periods`, payload, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                context.commit('setPeriod', res.data.periods);
            })
            .catch(error => this.dispatch('snackbar/error', error))

            context.commit('setLoading', false);
        },

        async savePeriod(context, payload) {
            let isSuccess = false;

            let url = '';
            if(payload.id != null) {
                url = 'update-period';
            } else {
                url = 'add-period';
                delete payload.id
            }

            await axios.post(`${this.state.host}/${url}`, payload, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                isSuccess = true;
                this.dispatch('snackbar/success', res.data.message);
                context.dispatch('getPeriods');
            })
            .catch(error => { 
                isSuccess = false;
                this.dispatch('snackbar/error', error);
            })

            return isSuccess;
        },

        async deletePeriod(context, id) {
            let isSuccess = false;

            await axios.delete(`${this.state.host}/delete-period/${id}`, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                isSuccess = true;
                this.dispatch('snackbar/success', res.data.message);
                context.dispatch('getPeriods');
            })
            .catch(error => { 
                isSuccess = false;
                this.dispatch('snackbar/error', error);
            })

            return isSuccess;
        }
    }
}
